import React, { FC, memo, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { ITaxiClassSectionProps } from "./types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAppSelector } from "store/hooks/useAppSelector";
import { useAppDispatch } from "store/hooks/useAppDispatch";
import { setTaxiClass } from "store/slices/taxiClass";
import { setCost } from "store/slices/orderCost";
import { shallowEqual } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { Tariff } from "./types";
import { ITariff } from "store/api/types";
import { mapTariffsWithIcons } from "./constants";
import timeStyles from "pages/OrderModal/components/TimeSection/TimeSection.styled";
import detailsStyles from "pages/OrderModal/components/DetailsSection/DetailsSection.styled";
import styles from "./TaxiClassSection.styled";

const TaxiClassSection: FC<ITaxiClassSectionProps> = ({ onBackClick }) => {
  const taxiClass = useAppSelector((state) => state.taxiClass, shallowEqual);
  const tariffsData = useAppSelector((state) => state.tariffs, shallowEqual);
  const settings = useAppSelector(
    (state) => state.settings.config,
    shallowEqual,
  );
  const [tariffsToRender, setTariffsToRender] = useState<Tariff[]>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (settings.tariffs) {
      setTariffsToRender(mapTariffsWithIcons(settings.tariffs));
    }
  }, [settings.tariffs]);

  const getOrder = (value: string) => {
    return tariffsData.find((data) => data.flexible_tariff_name === value);
  };

  const handleClick = (taxiObj: ITariff, cost: string) => () => {
    dispatch(
      setTaxiClass({
        value: taxiObj.name,
      }),
    );
    dispatch(setCost(cost));
    onBackClick();
  };

  return (
    <>
      <Box sx={{ ...timeStyles.headerWrap, ...styles.header }}>
        <IconButton onClick={onBackClick}>
          <ArrowBackIcon />
        </IconButton>
        <Typography component="h2" sx={timeStyles.title}>
          Клас авто
        </Typography>
      </Box>
      {!tariffsData.length ? (
        <Box sx={styles.skeletonWrap}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </Box>
      ) : (
        <List sx={{ ...detailsStyles.listWrap, ...styles.list }}>
          {tariffsToRender.map((taxiObj) => {
            const order = getOrder(taxiObj.name);

            return (
              <ListItemButton
                key={uuidv4()}
                sx={{
                  ...detailsStyles.innerItem(taxiObj.name === taxiClass.value),
                  ...styles.item,
                }}
                onClick={handleClick(
                  taxiObj,
                  order?.order_cost_details.order_cost || "",
                )}
              >
                <ListItemIcon sx={styles.carIcon(settings.accentColor.main)}>
                  <taxiObj.icon />
                </ListItemIcon>
                <ListItemText sx={styles.tariff} primary={taxiObj.name} />
                <ListItemText
                  sx={styles.costWrap}
                  primary={
                    <>
                      <Typography component="span" sx={styles.orderCost}>
                        {order?.order_cost_details.order_cost || "0"}
                      </Typography>
                      <Typography component="span" sx={styles.currency}>
                        ₴
                      </Typography>
                    </>
                  }
                />
              </ListItemButton>
            );
          })}
        </List>
      )}
    </>
  );
};

export default memo(TaxiClassSection);
